export const PREFERENCE_NAME_NEW_FEATURES_CLOSED = "new_features_closed";
export const PREFERENCE_NAME_NEW_FEATURES = "new_features_show_after";
export const ONE_DAY_MS = 24 * 60 * 60 * 1000;
export const ONE_YEAR_MS = 365 * ONE_DAY_MS;
